import { Injectable } from '@angular/core';

import { MxBrowserStorageService, MxStorageType } from './mx.browser-storage.service';

// eslint-disable-next-line max-len
@Injectable({
  providedIn: 'root',
})
export class MxAppColorSchemeService {
  private _colorScheme?: string;

  get colorScheme(): string {
    return this._colorScheme;
  }
  set colorScheme(value: string) {
    MxBrowserStorageService.set(MxStorageType.Local, 'color-scheme', value);

    this._colorScheme = value;
  }

  constructor() {
    this._colorScheme = MxBrowserStorageService.get(MxStorageType.Local, 'color-scheme');
  }

  changeStyleSheetsColor(id: any, value: any, from: any) {
    const element = document.getElementById(id);
    const urlTokens = element.getAttribute('href').split('/');

    if (this.colorScheme === 'dark') {
      document.body.classList.remove('light');
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
      document.body.classList.add('light');
    }

    if (from === 1) {
      // which function invoked this function - change scheme
      urlTokens[urlTokens.length - 1] = value;
    } else if (from === 2) {
      // which function invoked this function - change color
      urlTokens[urlTokens.length - 2] = value;
    }

    const newURL = urlTokens.join('/');

    this.replaceLink(element, newURL);
  }

  isIE() {
    return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
  }

  replaceLink(linkElement: any, href: any) {
    if (this.isIE()) {
      linkElement.setAttribute('href', href);
    } else {
      const id = linkElement.getAttribute('id');
      const cloneLinkElement = linkElement.cloneNode(true);

      cloneLinkElement.setAttribute('href', href);
      cloneLinkElement.setAttribute('id', id + '-clone');

      linkElement.parentNode.insertBefore(
        cloneLinkElement,
        linkElement.nextSibling
      );

      cloneLinkElement.addEventListener('load', () => {
        linkElement.remove();
        cloneLinkElement.setAttribute('id', id);
      });
    }
  }
}
